import React from "react";

export const BlogHero: React.FC = () => {
  return (
    <div className="mt-[100px] h-[443px] bg-black lg:mt-[400px] lg:bg-[#022928]">
      <div className="hidden lg:block">
        <img
          src="/assets/images/blog-bg.svg"
          alt="blog-bg"
          className="left-0 right-0 top-[120px] hidden h-[650px] w-full lg:absolute lg:top-[500px] lg:flex"
        />
        <div className="absolute left-0 right-0 top-[500px] hidden h-[650px] w-full bg-gradient-to-t from-[rgba(2,41,40,0.9)] via-[rgba(2,41,40,0.4)] to-transparent lg:block"></div>
      </div>
      <div className="absolute mx-[250px] mt-[120px] hidden w-[641.52px] lg:flex lg:flex-col">
        <div className="">
          <p className="font-inter text-[20px] font-medium leading-[100%] tracking-[-0.02em] text-[#FFFEFD]">
            Read, Learn, and Get Inspired in your Fundraising Journey
          </p>
          <p className="mt-3 font-inter text-[16px] leading-[140%] text-[#B3B3B3]">
            Discover heartwarming stories of impact and access expert resources
            to elevate your fundraising efforts. Get inspired and equipped with
            the tools you need to make a difference.
          </p>
        </div>
      </div>
      <div className="absolute top-[400px] mx-[16px] flex h-[448.95px] w-[calc(100%-32px)] flex-col items-end justify-end rounded-[20px] bg-gradient-to-b from-[#4FBA6D] via-[#2A7B45] to-[#022928] lg:hidden">
        <div className="p-12 px-[16px]">
          <p className="font-inter text-[20px] font-medium leading-[100%] tracking-[-0.02em] text-[#FFFEFD]">
            Read, Learn, and Get Inspired in your Fundraising Journey
          </p>
          <p className="mt-3 font-inter text-[16px] leading-[140%] text-[#B3B3B3]">
            Discover heartwarming stories of impact and access expert resources
            to elevate your fundraising efforts. Get inspired and equipped with
            the tools you need to make a difference.
          </p>
        </div>
      </div>
    </div>
  );
};
